import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { Store } from '@ngxs/store';

import { ApplicationConfig } from '../../config/application.config';
import { ApplicationActions } from '../../../shared/store/application/application.actions';
import { LanguageVersion } from '../../../shared/model/local/config/language-version';
import { ApplicationStateModel } from '../../../shared/store/application/application.state';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';

@Component({
  selector: 'app-preliminary-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    TranslatePipe,
    LanguageSwitcherComponent,
  ],
  templateUrl: './preliminary-layout.component.html',
  styleUrl: './preliminary-layout.component.scss',
})
export class PreliminaryLayoutComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private store = inject(Store);

  websiteUrl: string = ApplicationConfig.websiteUrl;

  language$ = this.store.select(
    (state: { application: ApplicationStateModel }) =>
      state.application.language
  );

  languageVersions: LanguageVersion[] = Object.values(
    LanguageVersion
  ) as LanguageVersion[];

  private routerSub?: Subscription;
  isRegisterPage = false;

  ngOnInit(): void {
    this.isRegisterPage = this.router.url.includes('/auth/register');

    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.isRegisterPage = e.url.includes('/auth/register');
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  goToWebsite(): void {
    window.location.href = this.websiteUrl;
  }

  createAccount(): void {
    this.router.navigate(['/auth/register']);
  }

  changeLanguage(lang: LanguageVersion): void {
    this.store.dispatch(new ApplicationActions.ChangeLanguage(lang));
  }
}
